module.exports = __webpack_public_path__ + "static/media/iStock-1129829504.b8a62451.gif";